import React from "react";
import { message } from "antd";
import FpCaptcha from "./fpcaptcha";
import { fetchRequest, getPlatform} from "../../config/Fatch.config";
import { ApiPort } from "../../actions/API";

class _Captcha extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            challengeUuid: "",
            keyUri: "", //拖动的image元素
            chartUri: "", //后端返回的待拼凑图表
            shuffleMatrix: [], //拼凑顺序
            loading: false,
            currentLocale:'',
        };
    }
    componentDidMount() {
	
	}
    componentDidUpdate(prevProps) {
        if (
            prevProps.captchaVisible !== this.props.captchaVisible &&
            this.props.captchaVisible === true
        ) {
            this.getCaptchaChallengeId();
        }
    }
    /**
     * 获取Uuid,这个Uuid是验证中用到的唯一Key
     */
    getCaptchaChallengeId = () => {
        const platform = getPlatform();
		const Apiversion = `?api-version=5.0&brand=JBO&Platform=${platform}`;
        
        const data = {
            captchaType: "SLIDE",
            applicationLanguage: "vi",
            siteId: 40,
        };
        this.setState({ loading: true });
        fetchRequest(ApiPort.CaptchaChallenge, 'POST',data, Apiversion)
            .then((res) => {
                if (res?.isSuccess) {
                    this.setState({
                        challengeUuid: res?.result?.challengeUuid,
                    });
                    this.getFpCaptcha(this.props.apiURL, res?.result?.challengeUuid);
                }
            })
            .catch((error) => {
                this.setState({ loading: false });
                console.log(error);
            });
    };
    /**
     * 获取初始的验证图形
     * @param {*} url
     * @param {*} id
     */
    getFpCaptcha = (url, id) => {
        const data = {
            applicationLanguage: "vi",
            device: {},
        };
        fetchRequest(url + "/api/v1.0/challenge/" + id, 'POST', data)
            .then((res) => {
                if (res) {
                    if (
                        ["10001", "10002", "11001"].includes(String(res?.code))
                    ) {
                        this.setState({
                            challengeUuid: res?.challengeUuid,
                            keyUri: res?.keyUri,
                            chartUri: res?.chartUri,
                            shuffleMatrix: res?.shuffleMatrix,
                            currentLocale: res?.currentLocale,
                        });
                    } else {
                        //63301:超过可换图次数  63302:Challenge過期或不存在（验证逾时）
                        this.getCaptchaChallengeId();
                    }
                }
            })
            .catch((error) => {
                this.setState({ loading: false });
                console.log(error);
            });
    };
    //判断坐标正确
    judgement = ({ x, y, cost }, callback) => {
        const { challengeUuid } = this.state;
        const {apiURL} = this.props;
        const data = {
            challengeUuid: challengeUuid,
            activity: {
                answers: { x: x, y: y },
                cost: cost,
            },
            applicationLanguage: "vi",
            device: {},
        };
        this.setState({ loading: true });
        fetchRequest(apiURL + "/api/v1.0/judgement",'POST', data)
            .then((res) => {
                if (res) {
                    typeof callback === "function" && callback(res?.code);
                    this.setState({ loading: false });
                }
            })
            .catch((error) => {
                console.log("坐标:", error?.message);
                this.setState({ loading: false });
                typeof callback === "function" && callback(error?.code);
            });
    };
    onReload = () => {
        //刷新加载img
        const { challengeUuid } = this.state;
        const {apiURL} = this.props;
        let data = {
            applicationLanguage: "vi",
            device: {},
        };
        this.setState({ loading: true });
        fetchRequest(apiURL + "/api/v1.0/chart/" + challengeUuid, 'POST', data)
            .then((res) => {
                if (["10001", "10002", "11001"].includes(String(res?.code))) {
                    this.setState({
                        chartUri: res?.chartUri,
                        keyUri: res?.keyUri,
                        shuffleMatrix: res?.shuffleMatrix,
                        currentLocale: res?.currentLocale,
                    });
                } else {
                    //63301:超过可换图次数  63302:Challenge過期或不存在（验证逾时）
                    this.getCaptchaChallengeId();
                }
            })
            .catch((error) => {
                message.error("网络错误，请重试");
                this.getCaptchaChallengeId();
            }).finally(()=>{
                this.setState({ loading: false });
            })
    };
    onclosed = (id) => {
        this.props.onMatch(id);
        this.props.setCaptchaVisible(false);
    };

    render() {
        const { keyUri, chartUri, shuffleMatrix, challengeUuid, loading,currentLocale  } =
            this.state;
        const { captchaVisible } = this.props;
        return (
           
                <FpCaptcha
                    visible={captchaVisible}
                    setVisible={this.props.setCaptchaVisible}
                    keyUri={keyUri}
                    chartUri={chartUri}
                    shuffleMatrix={shuffleMatrix}
                    challengeUuid={challengeUuid}
                    currentLocale={currentLocale}
                    judgement={this.judgement}
                    onMatch={this.onclosed}
                    onReload={this.onReload}
                    loading={this.state.loading}
                    setLoading={(v) => {
                        this.setState({ loading: v });
                    }}
                />
           
        );
    }
}

export default _Captcha;
